<template>
  <div class="ml_agreement">
    <div style="tab-interval:21pt;text-justify-trim:punctuation;">
      <div class="Section0" style="layout-grid:15.6000pt;">
        <p class=MsoNormal style="margin-bottom:15.6000pt;mso-para-margin-bottom:1.0000gd;text-align:center;">
          <b face="宋体">车赢云平台隐私权政策</b>
        </p>
        <p class=MsoNormal>
          <b face="宋体">简介</b>
        </p>
        <p class=MsoNormal>
          <span face="宋体">最新版本更新日期：2025年01月21日</span>
        </p>
        <p class=MsoNormal>
          <span face="宋体">最新版本生效日期：2025年01月21日</span>
        </p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">车赢云平台非常重视用户信息的保护，在使用车赢云平台及相关服务前，请您务必仔细阅读本隐私权政策，上海车赢信息技术有限公司</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（注册地址为上海市杨浦区国泰路</span>
            <span face="Times New Roman">11</span>
            <span face="宋体">号</span>
            <span face="Times New Roman">1</span>
            <span face="宋体">层展示厅</span>
            <span face="Times New Roman">A259</span>
            <span face="宋体">室）及其关联公司（</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">以下合称</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">公司</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">或</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">我们</span>
            <span face="Times New Roman">”)</span>
            <span face="宋体">可能会为向您依照《车赢云平台用户使用协议》提供相关服务而收集、使用、储存您的相关信息，您一旦选择使用车赢云平台产品及相关服务，即意味着同意公司按照本隐私权政策收集、使用</span>
            <span face="Times New Roman">(</span>
            <span face="宋体">含商业合作使用</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">、储存您的相关信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">提示条款</span>&nbsp;
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">隐私权政策适用于车赢云平台提供的客户端软件、网站、服务</span>(<span face="宋体">统称为</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台产品及服务</span>
            <span face="Times New Roman">”)</span>
            <span face="宋体">
              ，包括但不限于适用于电脑、移动智能终端的产品及服务。本隐私权政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据、会利用这些数据做什么以及我们如何保护这些数据。了解这些内容，对于您行使个人权利及保护您的个人信息至关重要，请您在使用车赢云平台产品及服务前务必抽出时间认真阅读本隐私权政策。当您开始下载、访问或使用车赢云平台产品及服务，即表示您已经同意本隐私权政策并信赖我们对您的信息的处理方式。请注意，您可以通过产品中的设置功能或控制项对您的信息进行动态管理，也可在手机上关闭系统的消息通知。我们同时提醒您，当您通过车赢云平台产品及服务使用第三方产品或服务时，您的信息应当适用第三方的隐私条款。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1<span face="宋体">、定义</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.1<span face="宋体">本产品</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：指由公司合法拥有并运营的、标注名称为车赢云平台客户端应用程序、公司经所属企业授权为其开发和维护的微信小程序，公司向用户提供的车赢云平台相关的技术服务。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.2<span face="宋体">关联公司</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：是指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、合法机构以及上述公司、合法机构的合法继承人。控制是指</span>(1)<span face="宋体">
              直接或间接持有过半数的投票权；或</span>
            <span face="Times New Roman">(2)</span>
            <span face="宋体">直接或间接享有过半数的可分配利润；或</span>
            <span face="Times New Roman">(3)</span>
            <span face="宋体">直接或间接控制董事会半数以上的成员的组成；或</span>
            <span face="Times New Roman">(4)</span>
            <span face="宋体">直接或间接持有半数的注册资本。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.3<span face="宋体">个人信息</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">指以电子或者其他方式记录与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.4<span face="宋体">敏感个人信息</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：指</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">包括身份证件号码、个人手机号码、邮箱、银行账号、行踪轨迹（定位信息）、交易信息等。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.5<span face="宋体">个人信息删除</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.6<span face="宋体">个人信息匿名化</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">1.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">7</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">所属企业</span>
            </span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：指您受其雇佣或为其服务的公司或其他组织。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">2<span face="宋体">、我们如何收集和使用您的信息</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              我们会出于本隐私权政策所述的以下目的，收集、存储和使用下列与您有关的个人信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些产品或服务，或者无法达到相关服务拟达到的效果。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">为便于阅读，我们以下方表格清单形式向您概括介绍我们所收集使用的您的个人信息情况。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ansi-font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">个人信息收集清单</span>
            </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ansi-font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <table class=MsoNormalTable style="border-collapse:collapse;">
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><b style="mso-bidi-font-weight:normal"><span style="font-family:宋体;mso-ansi-font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">收集个人信息的场景</span>
                  </span></b><b style="mso-bidi-font-weight:normal"><span style="font-family:宋体;mso-ansi-font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><b style="mso-bidi-font-weight:normal"><span style="font-family:宋体;mso-ansi-font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">涉及收集的个人信息字段</span>
                  </span></b><b style="mso-bidi-font-weight:normal"><span style="font-family:宋体;mso-ansi-font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">一键登录</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">手机号码</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">电子合同</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">手机号码、</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">身份证号码</span>
                    </span></u></b><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">网络检测</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">手机品牌型号、手机号码运营商</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">安全保障</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><b><u><span style="font-family:'Times New Roman';font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">搜索查询内容</span>
                    </span></u></b><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、</span>IP<span face="宋体">地址、浏览器的类型、使用的语言、访问服务的日期和时间、</span>
                  <span face="Times New Roman">cookies</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">&nbsp;web beacon</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">，此外我们还</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">会收集设备属性信息</span>(
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">包括</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">您的硬件型号、操作系统版本、设备配置、唯一设备标识符、国际移动设备身份码</span>IMEI<span face="宋体">、网络设备硬件地址</span>
                  <span face="Times New Roman">MAC</span>
                  <span face="宋体">、广告标识符</span>
                  <span face="Times New Roman">IDFA)</span>
                  <span face="宋体">，</span>
                </span><b><u><span style="font-family:'Times New Roman';font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">设备位置信息</span>
                    </span></u></b><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">(<span face="宋体">
                    如通过</span>
                  <span face="Times New Roman">GPS</span>
                  <span face="宋体">、蓝牙或</span>
                  <span face="Times New Roman">Wi-fi</span>
                  <span face="宋体">信号获得的位置信息</span>
                  <span face="Times New Roman">)</span>
                  <span face="宋体">、设备连接信息</span>
                  <span face="Times New Roman">(</span>
                  <span face="宋体">浏览器的类型、电信运营商、使用的语言</span>
                  <span face="Times New Roman">)</span>
                  <span face="宋体">以及设备状态信息</span>
                  <span face="Times New Roman">(</span>
                  <span face="宋体">例如设备传感器数据，设备应用安装列表</span>
                  <span face="Times New Roman">)</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">出险查询服务</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">行驶证照片、车架号、</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">身份证号</span>
                    </span></u></b><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、姓名、手机号</span>
                </span><b><u><span style="font-family:'Times New Roman';font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <o:p></o:p>
                    </span></u></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">维保查询服务</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">行驶证照片、车架号</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <o:p></o:p>
                    </span></u></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">“</span>
                  <span face="Times New Roman">E</span>
                  <span face="宋体">签保”认证服务</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">身份证号</span>
                    </span></u></b><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、姓名、手机号</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设置头像</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">或</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">更换头像</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal>
                <span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">上传的图片</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">视频</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">在线沟通</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">中</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">发送图片</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">功能</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">上传的图片</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">视频</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <o:p></o:p>
                    </span></u></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">使用视频沟通功能</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">上传的图片</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">视频</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <o:p></o:p>
                    </span></u></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆信息编辑</span>-<span face="宋体">车辆图片拍摄</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">车辆视频录制</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:50%;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;
mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">上传的图片</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">视频</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <o:p></o:p>
                    </span></u></b></p>
            </td>
          </tr>
        </table>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">2.1<span face="宋体">帮助您成为我们的用户</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">为成为我们的用户以便我们为您提供用户服务，您需要</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">线下联系客服人员提供姓名、联系电话、电子邮箱由专员为您开通账号</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您登录时，您需要提供您的手机号，您可以使用本机号码一键登录，或提供您手机号对应的密码进行登录。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您所属企业用户注销车赢云平台账号时，我们将会尽快匿名化处理或删除您在该组织的相关个人信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">2.2<span face="宋体">向您提供产品或服务</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">2.2.1<span face="宋体">您向我们提供的信息</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（</span>
            <span face="Times New Roman">1</span>
            <span face="宋体">）电子合同：为向您提供电子合同功能，您需要向我们提供手机号码、</span>
          </span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                <span face="宋体">身份证号码</span>
              </span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（</span>
            <span face="Times New Roman">2</span>
            <span face="宋体">）网络检测：为向您提供网络检测功能，您需要向我们提供手机品牌型号、手机号码运营商。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（</span>
            <span face="Times New Roman">3</span>
            <span face="宋体">）安全保障</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：当你使用</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台移动应用</span>
            <span face="Times New Roman">(App)</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">”</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">时，为了保障您正常使用</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">移动应用服务，更准确定位并解决您在使用</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">移动应用服务时遇到的问题，改进及优化</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">移动应用的服务体验，保障您的帐号安全，我们会自动收集您对我们服务的使用情况作为有关网络日志保存</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">，包括</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您的</span>
          </span><b><u><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
text-decoration:underline;text-underline:single;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                <span face="宋体">搜索查询内容</span>
              </span></u></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">、</span>IP<span face="宋体">地址、浏览器的类型、使用的语言、访问服务的日期和时间、</span>
            <span face="Times New Roman">cookies</span>
            <span face="宋体">、</span>
            <span face="Times New Roman">&nbsp;web beacon</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">，此外我们还</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">会收集设备属性信息</span>(
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">包括</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您的硬件型号、操作系统版本、设备配置、唯一设备标识符、国际移动设备身份码</span>IMEI<span face="宋体">、网络设备硬件地址</span>
            <span face="Times New Roman">MAC</span>
            <span face="宋体">、广告标识符</span>
            <span face="Times New Roman">IDFA)</span>
            <span face="宋体">，</span>
          </span><b><u><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
text-decoration:underline;text-underline:single;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                <span face="宋体">设备位置信息</span>
              </span></u></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(<span face="宋体">如通过</span>
            <span face="Times New Roman">GPS</span>
            <span face="宋体">、蓝牙或</span>
            <span face="Times New Roman">Wi-fi</span>
            <span face="宋体">信号获得的位置信息</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">、设备连接信息</span>
            <span face="Times New Roman">(</span>
            <span face="宋体">浏览器的类型、电信运营商、使用的语言</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">以及设备状态信息</span>
            <span face="Times New Roman">(</span>
            <span face="宋体">例如设备传感器数据，设备应用安装列表</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或电话号码与您的车赢云平台帐户相关联。同时，请您理解，当您将处于设备屏幕中
            </span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">移动应用切换到设备后台运行时，由于部分设备机型及系统原因，您此前使用</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">车赢云平台</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">移动应用相关功能而产生的信息收集行为，可能无法立即停止，从而导致短暂的后台信息收集行为。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal style="mso-list:l2 level1 lfo1;">
          <span style="font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>（4）</span></span>
          <b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">相机权限相关服务</span>
            </span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">：</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">1.<span face="宋体">设置我的头像</span></span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">或</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">更换头像</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">；或</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">2.<span face="宋体">在线沟通</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">发送图片</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">拍照</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">；或</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">3<span face="宋体">使用视频沟通功能</span></span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">；或进行</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">4.<span face="宋体">车辆信息编辑</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">车辆图片拍摄</span>
            <span face="Times New Roman">/</span>
            <span face="宋体">车辆视频录制</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">时，我们会调用您设备的相机权限以实现相应的图片、视频上传功能。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l2 level1 lfo1;">
          <span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'>（5）</span></span>
          <span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">出险查询服务：当您使用车赢云平台车险查询功能时，您需要提供行驶证照片、车架号、</span>
          </span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                <span face="宋体">身份证号</span>
              </span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">、姓名、手机号。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l2 level1 lfo1;">
          <span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'>（6）</span></span>
          <span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">维保查询服务：当您使用维保查询功能时，您需要提供行驶证照片、车架号。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l2 level1 lfo1;">
          <span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'>（7）</span></span>
          <span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您使用</span>
            <span face="宋体">“</span>
            <span face="Times New Roman">E</span>
            <span face="宋体">签保”认证服务时，您需要提供</span>
          </span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                <span face="宋体">身份证号</span>
              </span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">、姓名、手机号。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们向您提供的功能和服务场景是不断迭代升级的，如我们未在上述场景中明示您需要收集的个人信息，我们将会通过页面提示、交互设计等方式另行向您明示信息收集的内容、范围和目的并征得您同意。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">2.2.2 </span>
              <span face="宋体">我们接入的第三方</span>
              <span face="Times New Roman">SDK</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">需进行额外说明的是，为确保流畅的产品体验，您可能会收到来自车赢云平台及其合作伙伴外部的第三方</span>(<span face="宋体">下文简称</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">第三方</span>
            <span face="Times New Roman">”)</span>
            <span face="宋体">
              提供的内容或网络链接。我们对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。我们无法控制第三方的隐私和数据保护政策，此类第三方不受到本隐私权政策的约束。在向第三方提交个人信息之前，请自行查阅这些第三方的隐私保护政策并请您自行确定可以接受该等隐私保护政策。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              您在代表所属企业上传其成员或外部联系人的个人信息或其他数据前，应当确保已经事先取得了相关个人或权利人的明确同意，并且确保上述信息仅被用于收集时已经充分告知相关个人或权利人的目的和范围，并以收集时被告知的方式使用。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">第三方提供的连接、内容、产品和服务如下：</span>
          </span></p>
        <table border=1 cellspacing=0 style="width: calc(100vw - 30px); overflow: scroll;border-collapse:collapse;text-align: center;">
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal>
                <span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">SDK</span>
              </p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">功能</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">收集个人信息类型</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">隐私政策链接</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">极光推送</span>SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">提供推送</span>/<span face="宋体">下发通知栏信息服务</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">；</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">用于识别唯一用户，保证消息推送的精准送达；优化推送通道资源，我们会根据设备上不同</span>APP<span face="宋体">
                    的活跃情况，整合消息推送的通道资源，为开发者提高消息送达率；为开发者提供智能标签以及展示业务统计信息的服务</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">；优化</span>
                  <span face="Times New Roman">SDK</span>
                  <span face="宋体">与极光服务器的网络连接请求，保证服务的稳定性和连续性；实现区域推送的功能</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal>
                <span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、WIFI状态信息）  、设备标识符（包括IMEI、MAC、IMSI）、网络信息（包括SSID、BSSID、WiFi列表信息、基站信息）、软件列表信息（包括软件列表及软件运行列表信息）、位置相关信息
                </span>
              </p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://www.jiguang.cn/license/privacy</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">华为推送</span>SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">针对华为手机提供推送</span>/<span face="宋体">下发通知栏信息服务</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（</span>
                  <span face="Times New Roman">AAID</span>
                  <span face="宋体">、应用</span>
                  <span face="Times New Roman">Token</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">Topic</span>
                  <span face="宋体">订阅关系、标识符</span>
                  <span face="Times New Roman">HMS Core openId</span>
                  <span face="宋体">）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、地理位置信息、网络信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、消息下发记录、</span>
                  <span face="Times New Roman">Token</span>
                  <span face="宋体">申请记录、显示</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">点击</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">关闭打点上报记录、缓存消息内容</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">小米推送</span>SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">针对小米手机提供推送</span>/<span face="宋体">下发通知栏信息服务</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息（设备厂商、设备型号、设备内存、操作系统版本、小米推送</span>SDK<span face="宋体">版本、设备归属地（国家或地区）、</span>
                  <span face="Times New Roman">SIM</span>
                  <span face="宋体">卡运营商名称、当前网络类型、</span>
                  <span face="Times New Roman">WiFi</span>
                  <span face="宋体">状态。其中当前网络类型、</span>
                  <span face="Times New Roman">SIM</span>
                  <span face="宋体">卡运营商名称仅在设备本地读取，不会上传至小米服务器；）、地理位置信息、网络信息</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://dev.mi.com/console/doc/detail?pId=1822</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">OPPO<span
                    face="宋体">推送</span>
                  <span face="Times New Roman">SDK</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">针对</span>OPPO<span face="宋体">手机提供推送</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">下发通知栏信息服务</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息（手机</span>
                  <span face="Times New Roman">Region</span>
                  <span face="宋体">设置，设备型号，手机电量，手机操作系统版本及语言、网络配置信息等）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、地理位置信息、网络信息</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:9.0000pt;mso-font-kerning:1.0000pt;">https://open.oppomobile.com/new/developmentDoc/info?id=10288</span><span
                  style="font-family:'Times New Roman';font-size:9.0000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">VIVO<span
                    face="宋体">推送</span>
                  <span face="Times New Roman">SDK</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">针对</span>VIVO<span face="宋体">手机提供推送</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">下发通知栏信息服务</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备及应用信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（包括您使用</span>
                  <span face="Times New Roman">vivo</span>
                  <span face="宋体">设备及服务过程中的操作系统版本号、应用程序信息（包括应用安装列表）、设备标识符（如</span>
                  <span face="Times New Roman">IMEI</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">ICCID </span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">EMMCID/UFSID </span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">OAID/VAID/AAID </span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">SN</span>
                  <span face="宋体">码 和 </span>
                  <span face="Times New Roman">IMSI</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">Android id</span>
                  <span face="宋体">、移动国家码和</span>
                  <span face="Times New Roman">vivo Android</span>
                  <span face="宋体">设备的移动网号等）、</span>
                  <span face="Times New Roman">MAC</span>
                  <span face="宋体">地址、移动运营商、使用语言、系统设置、激活日期、运行时长等系统、设备和应用程序数据。）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、地理位置信息、网络信息、应用列表</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://www.vivo.com.cn/about-vivo/privacy-policy</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">友盟</span>+SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">统计分析</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备</span>Mac<span face="宋体">地址、唯一设备识别码（</span>
                  <span face="Times New Roman">IMEI/android ID/IDFA/OPENUDID/GUID</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">SIM </span>
                  <span face="宋体">卡 </span>
                  <span face="Times New Roman">IMSI </span>
                  <span face="宋体">信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、</span>
                  <span face="Times New Roman">IMEI</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">）、应用列表、</span>MAC<span face="宋体">地址</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://www.umeng.com/page/policy</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">io.dcloud<span
                    face="宋体">，</span>
                  <span face="Times New Roman">com.carwins.uni</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">应用基座</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（</span>
                  <span face="Times New Roman">IMEI</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">ANDROID_ID</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">DEVICE_ID</span>
                  <span face="宋体">、</span>
                  <span face="Times New Roman">IMSI</span>
                  <span face="宋体">），网络信息）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、获取运行中进程信息，获取</span>SD<span face="宋体">卡数据</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://ask.dcloud.net.cn/article/39484</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">DCloud uni-app(5+
                  App/Wap2App) </span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">统计分析</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备唯一识别码（</span>IMEI/android ID/DEVICE_ID/IDFA<span face="宋体">、</span>
                  <span face="Times New Roman">SIM </span>
                  <span face="宋体">卡 </span>
                  <span face="Times New Roman">IMSI </span>
                  <span face="宋体">信息、</span>
                  <span face="Times New Roman">OAID</span>
                  <span face="宋体">）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span class="23" style="font-family:宋体;font-size:10.5000pt;">
                  <span face="Times New Roman">https://dcloud.io/license/DCloud.html</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">极光认证</span>
                </span><span style="font-family:宋体;letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style="font-family:'Times New Roman';mso-spacerun:'yes';">&nbsp;</span></span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">一键登录</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal>
                <span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、ICCID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、WIFI状态信息）、手机号、设备标识符（包括IMEI、MAC、IMSI）、基站信息、软件列表信息（包括软件列表及软件运行列表信息）、位置相关信息
                </span>
              </p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.1000pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">https://www.jiguang.cn/license/privacy</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">极验</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">一键登录验证</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">（设备系统信息、设备厂商信息、设备型号、设备品牌、设备内存大小、设备系统语言等信息）</span>
                </span><span style="font-family:'Times New Roman';letter-spacing:-0.0500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                  <span face="宋体">、设备网络信息</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><a
                    href="https://www.geetest.co">https://www.geetest.co</a></span><span style="font-family:'Times New Roman';letter-spacing:-0.1500pt;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">m/Private</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">com.netease.nis</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">io.dcloud<span
                    face="宋体">应用基座</span></span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">获取</span>oaid&nbsp;<span face="宋体">设备信息</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">http://www.msa-alliance.cn/col.jsp?id=122</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">com.aliyun,<span
                    face="宋体">阿里云</span>
                  <span face="Times New Roman">SDK</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">io.dcloud<span
                    face="宋体">应用基座</span></span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">获取</span>oaid&nbsp;<span face="宋体">设备信息，获取</span>
                  <span face="Times New Roman">SD</span>
                  <span face="宋体">卡数据</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://ask.dcloud.net.cn/article/39484</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">微信</span>SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">信息分享</span>/<span face="宋体">用户付款</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（设备型号）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、应用列表</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">支付宝</span>SDK
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">用户付款</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（统设置、系统属性、设备型号、设备品牌、操作系统）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、网络信息、应用数据</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://opendocs.alipay.com/common/02kiq3</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">腾讯</span>X5<span face="宋体">浏览器</span>
                  <span face="Times New Roman">SDK</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">浏览</span>WEB<span face="宋体">页面</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">设备信息</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">（设备型号、操作系统、</span>
                  <span face="Times New Roman">CPU</span>
                  <span face="宋体">类型）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width:25%;padding:0 5px">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://x5.tencent.com/docs/privacy.html</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>

<tr><td width="63" valign="top" style="width:47.9500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;"><p class="MsoNormal"><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="宋体">阿里</font><font face="Times New Roman">weexSDK</font></span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></td><td width="198" valign="top" style="width:148.9000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;"><p class="MsoNormal"><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="Times New Roman">uni-app</font><font face="宋体">基础模块默认集成，用于渲染</font><font face="Times New Roman">uniapp</font><font face="宋体">的</font><font face="Times New Roman">nvue</font><font face="宋体">页面引擎</font></span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></td><td width="154" valign="top" style="width:116.1500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;"><p class="MsoNormal"><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="宋体">存储的个人文件、读取设备</font><font face="Times New Roman">IP</font></span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></td><td width="150" valign="top" style="width:113.1000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;"><p class="MsoNormal"><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="Times New Roman">https://weexapp.com/zh/</font></span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></td></tr>

        </table>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">2.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">3</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">征得授权同意的例外根据相关法律法规规定</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">以下情形中收集您的个人信息无需征得您的授权同意：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与国家安全、国防安全有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与公共安全、公共卫生、重大公共利益有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与犯罪侦查、起诉、审判和判决执行等有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;所收集的个人信息是您自行向社会公众公开的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="margin-left:22.0000pt;text-indent:-22.0000pt;mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;根据您的要求签订合同所必需的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;为合法的新闻报道所必需的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="margin-left:22.0000pt;text-indent:-22.0000pt;mso-list:l1 level1 lfo2;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;法律法规规定的其他情形。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">如我们停止运营本产品的功能或服务，我们将及时停止继续收集您个人信息的活动，将停止运营信息以通知或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">3<span face="宋体">、我们如何使用</span>
              <span face="Times New Roman">&nbsp;cookie</span>
              <span face="宋体">和同类技术</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">3.1Cookie</span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您使用本产品或服务时，为使您获得更轻松的访问体验，我们可能会使用各种技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个</span>&nbsp;Cookie<span
              face="宋体">或匿名标识符。这么做是为了了解您的使用习惯，使您省去重复输入注册信息等步骤。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您使用本产品或服务时，我们可能会利用</span>&nbsp;Cookie<span face="宋体">
              和同类技术收取您的信息用于了解您的偏好，进行咨询或数据分析，改善产品服务即用户体验，提高广告效果，及时发现并防范安全风险，为用户和合作伙伴提供更好的服务。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们不会将</span>&nbsp;Cookie<span face="宋体">用于本隐私政策所述目的之外的用途，您可以根据自己的偏好留存或删除</span>
            <span face="Times New Roman">&nbsp;Cookie</span>
            <span face="宋体">。您可清除软件或网页中保存的所有 </span>
            <span face="Times New Roman">Cookie</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">3.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">2</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">网站信标、像素标签和</span>ETag(<span face="宋体">实体标签</span>
              <span face="Times New Roman">)</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">除</span>Cookie <span face="宋体">外，我们还会在网站上使用网站信标、像素标签、</span>
            <span face="Times New Roman">ETag(</span>
            <span face="宋体">实体标签</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">等其他同类技术。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">ETag(<span face="宋体">实体标签</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">是在互联网浏览器与互联网服务器之间背后传送的</span>
            <span face="Times New Roman">HTTP</span>
            <span face="宋体">协议标头，可代替</span>
            <span face="Times New Roman">Cookie</span>
            <span face="宋体">。</span>
            <span face="Times New Roman">ETag(</span>
            <span face="宋体">实体标签</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过</span>
            <span face="Times New Roman">ETag(</span>
            <span face="宋体">实体标签</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。</span>
          </span><u><span style="mso-spacerun:'yes';font-family:'Times New Roman';text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</span>
            </span></u><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">但请注意，如果停用</span>ETag(<span face="宋体">实体标签</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">，您可能无法享受相对更佳的产品或服务体验。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">4<span face="宋体">、我们如何共享、转让、公开披露您的个人信息</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">4.1<span face="宋体">共享</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">除以下情形外，未经您的同意，我们不会与任何第三方共享您的个人信息：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的</span>&nbsp;<span face="宋体">
              个人信息有可能作为此类交易的一部分而被转移，我们将在转移前通知您，我们将按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的控制者继续保护你的个人信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（</span>
            <span face="Times New Roman">1</span>
            <span face="宋体">）</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              与关联公司间共享：与关联公司间共享：为便于我们基于关联账号共同向您提供服务，保护本产品或服务提供者的关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息
            </span>(<span face="宋体">如为便于您使用车赢云平台账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">（</span>
            <span face="Times New Roman">2</span>
            <span face="宋体">）</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与授权合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的授权合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">目前，我们的授权合作伙伴包括以下类型：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(i)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">软件服务提供商、智能设备提供商和系统服务提供商</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              本产品与第三方软件、设备系统结合为您提供基于位置的服务时，可能会基于您对系统定位的授权及设定，收取您的位置信息及设备信息并提供给系统。同时根据需要可能也会包含您另行填写的注册账号、昵称、等个人信息。如果您拒绝此类信息收集及使用，您需要在设备系统中进行设置或关闭提供服务的软件，本产品无法通过自动或手动设置关闭相关服务。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(ii)<span face="宋体">供应商、服务提供商和其他合作伙伴</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              我们可能将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、提供产品内或产品链接后的功能型服务，分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务和调查。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(iii)<span face="宋体">广告、分析服务类的授权合作伙伴</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">未经您的授权，我们不会将您的个人信息与提供广告、分析服务的合作伙伴共享。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal>
              <b face="宋体">具体与第三方共享个人信息的情况请见下列清单：</b>
        </p>

        <table border="1" style="width: calc(100vw - 30px); overflow: scroll;border-collapse:collapse;text-align: center;">
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">第三方名称</span>
                  </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">使用目的</span>
                  </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">处理方式</span>
                  </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">权限</span>
                    <span face="Times New Roman">/</span>
                    <span face="宋体">个人信息类型</span>
                  </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><span style="font-family:宋体;font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <span face="宋体">第三方联系方式</span>
                  </span></b><b><span style="font-family:'Times New Roman';font-weight:bold;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                    <o:p></o:p>
                  </span></b></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京百度网讯科技有限公司（百度开放平台）</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆图片分类识别</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆图片</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://privacy.baidu.com/policy/PrivacyPolicy</span><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">阿里云计算有限公司</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆图片背景模糊</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆图片</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">
                    https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107091605_49213.html
                  </span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京百度网讯科技有限公司（百度开放平台）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆</span>
                  <span face="Times New Roman">VIN</span>
                  <span face="宋体">码识别、行驶证和登记证信息涂抹</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">行驶证</span>
                  <span face="Times New Roman">/</span>
                  <span face="宋体">登记证图片</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://privacy.baidu.com/policy/PrivacyPolicy</span><span
                  style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><a
                    name="OLE_LINK10">
                    <span face="宋体">北京百度网讯科技有限公司（百度开放平台）</span>
                  </a></span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车牌遮挡</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆图片</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span
                  style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">https://privacy.baidu.com/policy/PrivacyPolicy</span><span
                  style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京恒泰博车拍卖有限公司<a name="OLE_LINK8">（博车网）</a></span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">报废车报价处理</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">车辆信息、用户姓名和手机号码</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">400622899</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">天津车易保网络科技有限公司（查博士）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><a
                    name="OLE_LINK2">
                    <span face="宋体">维保报告查询</span>
                  </a></span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><a
                    name="OLE_LINK3">
                    <span face="宋体">行驶证照片、</span>
                    <span face="Times New Roman">VIN</span>
                    <span face="宋体">码</span>
                  </a></span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">https://www.chaboshi.cn/privacyAgreement</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京盛拓鸿远信息技术有限公司（汽车之家）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">维保报告查询</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">行驶证照片、</span>
                  <span face="Times New Roman">VIN</span>
                  <span face="宋体">码</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">4009616666</span><span
                  style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京与车行信息技术有限公司（柠檬查</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">出险报告查询</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">身份证</span>
                    </span></u></b><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">、姓名、手机号</span>
                </span><span class="23" style="font-family:宋体;font-size:10.5000pt;">
                  <span face="宋体">、行驶证照片、车架号</span>
                </span><span style="font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">18601127372</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">杭州天谷信息科技有限公司（</span>
                  <span face="Times New Roman">e</span>
                  <span face="宋体">签宝）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">实名认证、电子合同</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:Arial;color:rgb(11,38,64);font-size:10.5000pt;
mso-font-kerning:1.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">手机号、姓名、</span>
                </span><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                      <span face="宋体">身份证号</span>
                    </span></u></b><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">https://www.esign.cn/gw/fwxy/</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
          <tr>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">北京恒泰博车拍卖有限公司（博车网）</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="宋体">事故报告查询</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">API</span>
                  <span face="宋体">传输</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">VIN</span>
                  <span face="宋体">码</span>
                </span><span style="font-family:宋体;font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
            <td valign=top style="width: 20%;padding:0 5px;">
              <p class=MsoNormal><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <span face="Times New Roman">400622899</span>
                </span><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
                  <o:p></o:p>
                </span></p>
            </td>
          </tr>
        </table>

        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">&nbsp;</span><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">4.2<span face="宋体">转让</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              在我们发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私权政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">4.3<span face="宋体">公开披露</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们仅会在以下情况下，公开披露您的个人信息：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              如果我们确定您出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及本产品已对您采取的措施。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">4.4<span face="宋体">共享、转让、公开披露个人信息时事先征得授权同意的例外</span></span></b><b><span
              style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与国家安全、国防安全有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与公共安全、公共卫生、重大公共利益有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;与犯罪侦查、起诉、审判和判决执行等有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人的同意的。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;您自行向社会公众公开的个人信息；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l0 level1 lfo3;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="margin-left:22.0000pt;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5<span face="宋体">、我们如何保护您的个人信息安全</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.1</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">本产品会采取适当的符合业界标准的安全措施和技术手段存储和保护您的个人信息，以防止其丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏，如通过网络安全层技术</span>SSL<span
              face="宋体">进行加密传输、信息加密存储、严格限制数据中心的访问、使用专用网络通道及网络代理。您的个人信息存放在有密码控制的服务器中，访问均是受到限制的。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.2</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              我们对可能接触到您的信息的工作人员采用最小够用授权原则。即我们仅允许有必要知晓这些信息的本产品和其关联公司的员工在采取合理的措施验证身份之后，访问或修改这些信息。同时，我们会严格要求他们履行保密及安全义务，如果未能履行这些义务，其会被追究法律责任或被终止与本产品的合作关系。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.3</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">为了保护您的信息安全，如果用户个人信息有误，本产品会在严格验证并核实申请人身份后，根据用户要求访问、修正或删除相关信息</span>(<span face="宋体">
              除非本产品出于合法的原因而必须保留这些个人信息</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.4</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本隐私权政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.5</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">互联网并非绝对安全的环境，电子邮件、即时通讯、社交软件、交易平台等与其他用户的交流方式无法确定是否完全加密，请您在进行交互使用时，注意保护您个人信息的安全。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.6</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              请您理解，由于计算机及互联网技术的飞速发展及同步速度的限制，可能存在或出现各种恶意或非恶意的攻击手段。虽然本产品持续致力于提升和加强安全措施，以保护您的信息免遭意外或破坏，但仍无法始终保证信息的百分之百安全。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.7</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您使用产品或服务时所用的系统和通讯网络，或硬件设备等本产品均无法控制，请您了解并注意保护您的个人信息安全。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.8</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              请注意，您在使用我们产品和服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.9</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.10</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">5.11</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">
              请您知悉：车赢云平台提供的个人信息保护措施仅适用于车赢云平台产品和服务，一旦您离开车赢云平台，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在车赢云平台之外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于车赢云平台的链接或引导。
            </span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6<span face="宋体">、您如何管理您的个人信息</span></span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过以下方式访问及管理您的个人信息：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6.1</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">查阅、复制、更正或补充</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">您的个人信息</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您有权</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">查阅、复制、更正或补充</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">查阅、复制、更正或补充</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您的个人信息：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoCommentText><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过</span>
            <span face="宋体">“首页</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">左上角头像</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">姓名”查阅、复制、更改您的个人头像。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoCommentText><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过</span>
            <span face="宋体">“首页</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">左上角头像</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">设置</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">账号与安全</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">修改账号密码”进行密码查阅、复制、修改。</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">2</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">删除您的个人信息</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过</span>
            <span face="Times New Roman">“6.1</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">查阅、复制</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您的个人信息</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">中列明的方式删除您的部分个人信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">在以下情形中，您可以向我们提出删除个人信息的请求：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(i)<span face="宋体">如果我们处理个人信息的行为违反法律法规；</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(ii)<span face="宋体">如果我们收集、使用您的个人信息，却未征得您的明确同意；</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(iii)<span face="宋体">如果我们处理个人信息的行为严重违反了与您的约定；</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(iv)<span face="宋体">如果您不再使用我们的产品或服务，或您主动注销了账号；</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">(v)<span face="宋体">如果我们永久不再为您提供产品或服务。</span></span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">3</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">改变您授权同意的范围</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">每个业务功能需要一些基本的个人信息才能得以完成</span>(<span face="宋体">详见本隐私权政策其他部分</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">。除此之外，您可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过关闭功能的方式撤销部分授权。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">4</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">个人信息主体注销账户</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过所属企业在</span>
            <span face="Times New Roman">“</span>
            <span face="宋体">企业管理后台组织架构功能</span>
            <span face="Times New Roman">”</span>
            <span face="宋体">页面提交删除员工信息</span>
            <span face="Times New Roman">(</span>
            <span face="宋体">即账户注销</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">申请。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">在您的所属企业为您注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">6.</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">5</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">响应您的上述请求</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">我们将在</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="Times New Roman">15</span>
            <span face="宋体">个工作日</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">内做出答复。如您不满意，还可以通过本隐私政策第</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="Times New Roman">8</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">条载明的客服联系方式发起投诉。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段</span>(<span face="宋体">
              例如，需要开发新系统或从根本上改变现行惯例</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(i)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">与国家安全、国防安全有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(ii)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">与公共安全、公共卫生、重大公共利益有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(iii)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">与犯罪侦查、起诉、审判和执行判决等有关的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(iv)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(v)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">(vi)</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">涉及商业秘密的。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">7</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">、本隐私权政策如何更新</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">7</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">.1<span face="宋体">我们的隐私权政策可能变更。</span></span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">7</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">.2</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面</span>(<span face="宋体">我的</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">设置关于</span>
            <span face="Times New Roman">-</span>
            <span face="宋体">隐私权政策</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">发布对隐私权政策所做的任何变更。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">7</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">.3</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">对于重大变更，我们还会提供更为显著的通知</span>(<span face="宋体">包括我们会通过车赢云平台网站公示的方式进行通知甚至向您提供弹窗提示</span>
            <span face="Times New Roman">)</span>
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">本隐私权政策所指的重大变更包括但不限于：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;个人信息共享、转让或公开披露的主要对象发生变化；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="mso-list:l3 level1 lfo4;">
          <span style="font-family:Wingdings;font-size:10.5000pt;mso-font-kerning:1.0000pt;"><span
              style='mso-list:Ignore;'><span>&nbsp;</span></span></span>
          <span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">&nbsp;&nbsp;&nbsp;&nbsp;个人信息安全影响评估报告表明存在高风险时。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span>
        </p>
        <p class=MsoNormal style="margin-left:22.0000pt;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">8</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">、如何联系我们</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
            </span></b></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">您可以通过以下方式与我们联系，我们将在</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="Times New Roman">15</span>
            <span face="宋体">个工作日</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">内回复您的请求：</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">8</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">.1</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">如对本隐私权政策内容有任何疑问、意见或建议，您都可以通过拨打我们的客服电话</span>400-0226-698<span face="宋体">或通过发送邮件至</span>
            <span face="Times New Roman">&nbsp;service@carwins.com</span>
            <span face="宋体">与我们联系。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="Times New Roman">8</span>
            </span></b><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">.2</span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案</span>
          </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <span face="宋体">。</span>
          </span><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p>&nbsp;</o:p>
            </span></b></p>
        <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <span face="宋体">上海车赢信息服务有限公司</span>
            </span></b><span style="mso-spacerun:'yes';font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p></o:p>
          </span></p>
        <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
            <o:p>&nbsp;</o:p>
          </span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() { },
  methods: {},
};
</script>
<style lang='scss' scoped>
.ml_agreement {
  padding: 15px;

  p,
  span {
    color: #292d33 !important;
    line-height: 26px !important;
  }
}

@font-face {
  font-family: "Times New Roman";
}

@font-face {
  font-family: "宋体";
}

@font-face {
  font-family: "Wingdings";
}

@font-face {
  font-family: "等线 Light";
}

@font-face {
  font-family: "Arial";
}

@list l0:level1 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F09F;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 22.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level2 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 44.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level3 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 66.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level4 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 88.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level5 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 110.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level6 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 132.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level7 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 154.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level8 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 176.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l0:level9 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 198.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level1 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F09F;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 22.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level2 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 44.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level3 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 66.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level4 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 88.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level5 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 110.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level6 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 132.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level7 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 154.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level8 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 176.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l1:level9 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 198.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l2:level1 {
  mso-level-start-at: 4;
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "（%1）";
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level1 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F09F;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 22.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level2 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 44.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level3 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 66.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level4 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 88.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level5 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 110.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level6 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 132.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level7 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06C;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 154.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level8 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F06E;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 176.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

@list l3:level9 {
  mso-level-number-format: bullet;
  mso-level-suffix: tab;
  mso-level-text: \F075;
  mso-level-tab-stop: none;
  mso-level-number-position: left;
  margin-left: 198.0000pt;
  text-indent: -22.0000pt;
  font-family: Wingdings;
}

p.MsoNormal {
  mso-style-name: 正文;
  mso-style-parent: "";
  margin: 0pt;
  margin-bottom: .0001pt;
  mso-pagination: none;
  text-align: justify;
  text-justify: inter-ideograph;
  font-family: 'Times New Roman';
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

h1 {
  mso-style-name: "标题 1";
  mso-style-next: 正文;
  margin-top: 24.0000pt;
  margin-bottom: 4.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 1;
  font-family: '等线 Light';
  mso-bidi-font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-size: 24.0000pt;
  mso-font-kerning: 1.0000pt;
}

h2 {
  mso-style-name: "标题 2";
  mso-style-next: 正文;
  margin-top: 8.0000pt;
  margin-bottom: 4.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 2;
  font-family: '等线 Light';
  mso-bidi-font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-size: 20.0000pt;
  mso-font-kerning: 1.0000pt;
}

h3 {
  mso-style-name: "标题 3";
  mso-style-next: 正文;
  margin-top: 8.0000pt;
  margin-bottom: 4.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 3;
  font-family: '等线 Light';
  mso-bidi-font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-size: 16.0000pt;
  mso-font-kerning: 1.0000pt;
}

h4 {
  mso-style-name: "标题 4";
  mso-style-next: 正文;
  margin-top: 4.0000pt;
  margin-bottom: 2.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 4;
  font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-size: 14.0000pt;
  mso-font-kerning: 1.0000pt;
}

h5 {
  mso-style-name: "标题 5";
  mso-style-next: 正文;
  margin-top: 4.0000pt;
  margin-bottom: 2.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 5;
  font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-size: 12.0000pt;
  mso-font-kerning: 1.0000pt;
}

h6 {
  mso-style-name: "标题 6";
  mso-style-next: 正文;
  margin-top: 2.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 6;
  font-family: 'Times New Roman';
  color: rgb(15, 71, 97);
  font-weight: bold;
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeading7 {
  mso-style-name: "标题 7";
  mso-style-next: 正文;
  margin-top: 2.0000pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 7;
  font-family: 'Times New Roman';
  color: rgb(89, 89, 89);
  font-weight: bold;
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeading8 {
  mso-style-name: "标题 8";
  mso-style-next: 正文;
  margin: 0pt;
  margin-bottom: .0001pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 8;
  font-family: 'Times New Roman';
  color: rgb(89, 89, 89);
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

p.Msoheading9 {
  mso-style-name: "标题 9";
  mso-style-next: 正文;
  margin: 0pt;
  margin-bottom: .0001pt;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 9;
  font-family: 'Times New Roman';
  mso-fareast-font-family: '等线 Light';
  color: rgb(89, 89, 89);
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}



p.MsoCommentText {
  mso-style-name: 批注文字;
  mso-style-noshow: yes;
  margin: 0pt;
  margin-bottom: .0001pt;
  mso-pagination: none;
  text-align: left;
  font-family: 'Times New Roman';
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoFooter {
  mso-style-name: 页脚;
  mso-style-noshow: yes;
  margin: 0pt;
  margin-bottom: .0001pt;
  layout-grid-mode: char;
  mso-pagination: none;
  text-align: left;
  font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeader {
  mso-style-name: 页眉;
  mso-style-noshow: yes;
  margin: 0pt;
  margin-bottom: .0001pt;
  layout-grid-mode: char;
  mso-pagination: none;
  text-align: center;
  font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoSubtitle {
  mso-style-name: 副标题;
  mso-style-next: 正文;
  margin-bottom: 8.0000pt;
  mso-pagination: none;
  text-align: center;
  font-family: '等线 Light';
  mso-bidi-font-family: 'Times New Roman';
  color: rgb(89, 89, 89);
  letter-spacing: 0.7500pt;
  font-size: 14.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.pre {
  mso-style-name: "HTML 预设格式";
  mso-style-noshow: yes;
  margin: 0pt;
  margin-bottom: .0001pt;
  mso-pagination: none;
  text-align: left;
  font-family: 宋体;
  font-size: 12.0000pt;
}

p.MsoTitle {
  mso-style-name: 标题;
  mso-style-next: 正文;
  margin-bottom: 4.0000pt;
  mso-add-space: auto;
  mso-pagination: none;
  text-align: center;
  font-family: '等线 Light';
  mso-bidi-font-family: 'Times New Roman';
  letter-spacing: -0.5000pt;
  font-size: 28.0000pt;
  mso-font-kerning: 14.0000pt;
}

p.MsoCommentSubject {
  mso-style-name: 批注主题;
  mso-style-noshow: yes;
  mso-style-parent: 批注文字;
  mso-style-next: 批注文字;
  margin: 0pt;
  margin-bottom: .0001pt;
  mso-pagination: none;
  text-align: left;
  font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}
span.msoIns {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: underline;
  text-underline: single;
  color: blue;
}

span.msoDel {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: line-through;
  color: red;
}

table.MsoNormalTable {
  mso-style-name: 普通表格;
  mso-style-parent: "";
  mso-style-noshow: yes;
  mso-tstyle-rowband-size: 0;
  mso-tstyle-colband-size: 0;
  mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
  mso-para-margin: 0pt;
  mso-para-margin-bottom: .0001pt;
  mso-pagination: widow-orphan;
  font-family: 'Times New Roman';
  font-size: 10.0000pt;
  mso-ansi-language: #0400;
  mso-fareast-language: #0400;
  mso-bidi-language: #0400;
}

@page {
  mso-page-border-surround-header: no;
  mso-page-border-surround-footer: no;
}

@page Section0 {
  margin-top: 72.0000pt;
  margin-bottom: 72.0000pt;
  margin-left: 90.0000pt;
  margin-right: 90.0000pt;
  size: 595.3000pt 841.9000pt;
  layout-grid: 15.6000pt;
  mso-header-margin: 42.5500pt;
  mso-footer-margin: 49.6000pt;
}

div.Section0 {
  page: Section0;
}

table tr td {
  box-sizing: border-box;
  word-break: break-all;
  word-wrap: break-word;
}
</style>